export default __webpack_public_path__ + "static/media/certification.d3f60f96.svg";